<template>
  <div>
    <transition name="o-transition__fade" mode="out-in">
      <picture class="c-picture" @click="this.expand">
        <img :src="$api + src" alt="" />
      </picture>
    </transition>
    <CallCenterAEDModal
      v-if="expanded"
      @close="this.expand"
      :cornerClose="false"
    >
      <img
        :src="$api + src"
        alt=""
        class="c-picture--expanded"
        slot="body"
        @click="this.expand"
      />
    </CallCenterAEDModal>
  </div>
</template>

<script>
export default {
  name: "c-picture",
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    expand() {
      this.expanded = !this.expanded;
    }
  },
  props: {
    src: { type: String, required: true }
  }
};
</script>
<style lang="scss">
.c-picture {
  height: 100%;
  display: block;
  cursor: zoom-in;
  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }
  &--expanded {
    @include u-fill(50%, 0, 0, 50%);
    transform: translate(-50%, -50%);
    width: 100%;
    cursor: zoom-out;
  }
}
</style>
